import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase-config";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export async function requestFirebaseNotificationPermission() {
	try {
		const token = await getToken(messaging, { vapidKey: VAPID_KEY });
		return token;
	} catch (err) {
		console.error("Error obtaining FCM token:", err);
		return null;
	}
}

export function onFirebaseMessage(callback: (payload: any) => void) {
	onMessage(messaging, callback);
}
